import Vue from 'vue';

export const alert = {
    namespaced: true,
    state: {},
    getters: {},
    actions: {
        success({commit}, message) {
            commit('success', message);
        },
        error({commit}, message) {
            commit('error', message);
        }
    },
    mutations: {
        success(state, message) {
            Vue.toasted.show(message, {
                theme: 'outline',
                position: "top-right",
                icon: 'times',
                type: 'success',
                duration: 2000
            });
        },
        error(state, message) {
            Vue.toasted.show(message, {
                theme: 'outline',
                position: "top-right",
                icon: 'times',
                type: 'error',
                duration: 2000
            });
        }
    }
}